<template>
  <div class="container-fluid mt-4">
    <div class="row align-items-center">
      <!--<div class="col-lg-4 col-sm-8">
        <nav-pill />
      </div> -->
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="row mt-4">
          <!--<div class="col-xl-6 mb-xl-0 mb-4">
            <master-card />
          </div>
          <div class="col-md-6">
            <default-info-card
              icon="text-white fas fa-landmark"
              title="收钱吧"
              description="收钱吧通道"
              value="2192个"
            />
          </div>
          <div class="col-xl-6">
            <div class="row">
              <div class="col-md-6">
                <default-info-card
                  icon="text-white fab fa-weixin"
                  title="微信官方"
                  description="自营微信官方通道"
                  value="1098个"
                />
              </div>
              <div class="col-md-6">
                <default-info-card
                  icon="text-white fab fa-alipay"
                  title="支付宝官方"
                  description="自营支付宝官方通道"
                  value="1098个"
                />
              </div>
            </div>
          </div> -->
          <div class="col-md-12 mb-4">
            <approve-submission />
          </div>
        </div>
      </div>
      <!--
      <div class="col-lg-4"> 如果要启动这个表格，就要把上面的col-lg-12改成col-lg-8
        <invoice-card />
      </div> -->
    </div>

  </div>
</template>

<script>
import setTooltip from "@/assets/js/tooltip.js";
//import NavPill from "./components/NavPill.vue";
//import MasterCard from "@/examples/Cards/MasterCard.vue";
//import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
import ApproveSubmission from "./ApproveSubmission.vue";

export default {
  name: "Submission",
  components: {
    ApproveSubmission,
  },
  mounted() {
    setTooltip();
  },
};
</script>
